module.exports = __webpack_public_path__ + "modern.jpg?861a0ed3def5d49d70c45ff3ab23c064";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/modern.jpg
// module id = 9
// module chunks = 0